import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  Container: {
    paddingBottom: '30px',
  },
  Label: {
    color: theme.palette.common.darkerText,
    display: 'block',
    padding: '0px',
    fontSize: '14px',
    lineHeight: '20px',
    marginBottom: '4px',
  },
  Textarea: {
    resize: 'none',
    width: '100%',
    height: '160px',
    borderRadius: '6px',
    padding: '12px',
    fontSize: '15px',
    borderColor: theme.palette.xpl.stoke,
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.xpl.secondary.default,
    },
  },
});
const SuspensionReasonTextarea = (props) => {
  const { classes, register } = props;

  return (
    <div className={classes.Container}>
      <label className={classes.Label} htmlFor="suspensionReason">
        Reason for Suspension
      </label>
      <div className={classes.TextareaContainer}>
        <textarea
          className={classes.Textarea}
          ref={register}
          name="suspensionReason"
          id="suspensionReason"
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(SuspensionReasonTextarea);
